import Close from '@mui/icons-material/Close';
import { Box, Button, Grid, Tooltip, Typography } from '@mui/material';
import classNames from 'classnames';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { defaultSubjectHeight, deleteNotificationClass, notificationCardTitleClass, notificationColors, notificationStatusClass, } from '../../constants';
import { useNotificationsContext } from '../../hooks/contexts/useNotificationsContext';
var makeSxStyles = function (_a) {
    var fullHeight = _a.fullHeight, isOpen = _a.isOpen, viewed = _a.viewed;
    var status = notificationColors.status;
    return {
        wrapper: {
            position: 'relative',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        titleWrapper: {
            maxWidth: 'calc(100% - 65px)',
        },
        title: {
            display: isOpen ? "block" : '-webkit-box',
            '-webkit-box-orient': 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'normal',
            '-webkit-line-clamp': isOpen ? 'none' : 1,
            height: isOpen ? "".concat(fullHeight, "px") : "".concat(defaultSubjectHeight, "px"),
            lineHeight: "".concat(defaultSubjectHeight, "px"),
            transition: function (theme) {
                return theme.transitions.create('height', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.enteringScreen,
                });
            },
            fontSize: 16,
            fontWeight: viewed ? 500 : 700,
        },
        actionsPanel: {
            position: 'absolute',
            top: 0,
            right: 0,
            height: '100%',
            display: 'flex',
            alignItems: 'center',
        },
        notificationStatus: {
            border: "1px solid ".concat(status.border),
            borderRadius: '50%',
            width: '15px',
            height: '15px',
            transition: function (theme) {
                return theme.transitions.create('background', {
                    easing: theme.transitions.easing.easeInOut,
                    duration: theme.transitions.duration.short,
                });
            },
            cursor: 'pointer',
            background: viewed ? function (theme) { return theme.palette.background.paper; } : status.active,
            '&:not(.viewed)': {
                background: status.active,
            },
            '&.viewed': {
                background: function (theme) { return theme.palette.background.paper; },
            },
        },
        deleteButton: {
            minWidth: 'unset',
            padding: '0px',
            paddingLeft: function (theme) { return theme.spacing(1.5); },
            background: 'none !important',
            border: 'none',
            display: 'flex',
            alignItems: 'center',
        },
        closeIcon: {
            width: '19px',
            height: '19px',
        },
    };
};
export var NotificationCardHeader = function (props) {
    var subjectMessage = props.subjectMessage, viewed = props.viewed, isOpen = props.isOpen, id = props.id, setNeedSubjectCollapse = props.setNeedSubjectCollapse;
    var _a = useNotificationsContext(), deleteNotification = _a.deleteNotification, toggleViewed = _a.toggleViewed;
    var formatMessage = useIntl().formatMessage;
    var subjectMessageRef = useRef(null);
    var _b = useState(defaultSubjectHeight), fullHeight = _b[0], setFullHeight = _b[1];
    var _c = useState(false), isDeleteDisabled = _c[0], setIsDeleteDisabled = _c[1];
    var sx = makeSxStyles({ viewed: viewed, isOpen: isOpen, fullHeight: fullHeight });
    var notificationStatusClassName = classNames(notificationStatusClass, {
        viewed: viewed,
    });
    useEffect(function () {
        if (subjectMessageRef.current) {
            var _a = subjectMessageRef.current, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
            setFullHeight(scrollHeight);
            setNeedSubjectCollapse(scrollHeight !== clientHeight);
        }
    }, [subjectMessageRef, setFullHeight, setNeedSubjectCollapse, viewed]);
    var enableDeleteBtn = function () {
        setIsDeleteDisabled(false);
    };
    var handleDelete = useCallback(function () {
        setIsDeleteDisabled(true);
        deleteNotification(id, viewed, enableDeleteBtn);
    }, [id, deleteNotification, viewed, setIsDeleteDisabled]);
    var handleToggleViewed = useCallback(function () {
        return toggleViewed(id, !viewed);
    }, [id, toggleViewed, viewed]);
    var tooltipTitle = formatMessage({
        id: viewed ? 'notification.markAsNotViewed' : 'notification.markAsViewed',
        defaultMessage: viewed ? 'Отметить как непрочитанное' : 'Отметить как прочитанное',
    });
    return (React.createElement(Grid, { container: true, spacing: 1, wrap: "nowrap", sx: sx.wrapper },
        React.createElement(Grid, { item: true, sx: sx.titleWrapper },
            React.createElement(Typography, { ref: subjectMessageRef, component: "h2", sx: sx.title, className: notificationCardTitleClass }, subjectMessage)),
        React.createElement(Grid, { item: true, spacing: 0, sx: sx.actionsPanel },
            React.createElement(Grid, { container: true, spacing: 0, alignItems: "center", wrap: "nowrap" },
                React.createElement(Grid, { item: true },
                    React.createElement(Tooltip, { title: tooltipTitle },
                        React.createElement(Box, { onClick: handleToggleViewed, sx: sx.notificationStatus, className: notificationStatusClassName }))),
                React.createElement(Grid, { item: true, container: true },
                    React.createElement(Button, { disabled: isDeleteDisabled, onClick: handleDelete, sx: sx.deleteButton, className: deleteNotificationClass },
                        React.createElement(Close, { fontSize: "small", sx: sx.closeIcon })))))));
};
